import React from "react";

function WifyIcon({ style, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      className={className}
      style={{
        shapeRendering: "geometricPrecision",
        textRendering: "geometricPrecision",
        imageRendering: "optimizeQuality",
        fillRule: "evenodd",
        clipRule: "evenodd",
        ...style
      }}
      viewBox="0 0 890 890"
    >
      <path
        d="M8 609c72-2 143 24 196 77 54 53 79 124 77 196L0 890l8-281zm4-129c105-3 209 34 287 111 77 78 114 182 111 287l173-5c5-149-48-297-159-407C314 355 166 303 17 307l-5 173zm9-303c182-5 363 59 498 194s199 316 194 498l177-5c7-228-74-453-242-622C479 74 254-6 26 0l-5 177z"
        style={{
          // fill: "#2b2a29",
        }}
      />
    </svg>
  );
}

export default WifyIcon;
